export default "__VITE_ASSET__BizNhXxk__"